import React from 'react'
import { ToggleSwitch } from '../ToggleSwitch'

type DataTableToggleProps = {
  checked?: boolean
  disabled?: boolean
  ariaLabel?: string
  onChange?: (checked: boolean) => void
}

const DataTableToggle: React.FC<DataTableToggleProps> = ({
  checked = false,
  disabled = false,
  ariaLabel = 'Toggle row',
  onChange,
}) => (
  <ToggleSwitch
    checked={checked}
    disabled={disabled}
    aria-label={ariaLabel}
    onChange={onChange}
  />
)

export default DataTableToggle
